/* global FLAGSMITH_ENV, FLAGSMITH_API, VERSION */

import flagsmith from 'flagsmith'
import Promise from 'bluebird'

// These define the local state
const sharedStorage = window.sessionStorage

// Callback for flag updates
var updateCallback = null

// Old flags (for update callback)
var oldFlags = {}

// Increasing callback handle (to cancel active timeout in case of reinitialization)
var currentCallbackHandle = 0

const FLAGS = {
  auto_move_cards: { defaultValue: true, isConfig: false },
  sohnd_list_sorter: { defaultValue: true, isConfig: false },
  feature_flags_update_interval: { defaultValue: 15 * 60 * 1000, isConfig: true } // Every 15 Minutes
}

// Note if flagsmith has been initialized (otherwise it hangs)
var flagsmithInitialized = false

export function init (t) {
  const DEFAULT_FLAGS = {}
  for (const key in FLAGS) {
    DEFAULT_FLAGS[key] = FLAGS[key].defaultValue
  }
  storeFlags(DEFAULT_FLAGS)

  const context = t.getContext()
  var ids = [null] // First id is null to get default values in the beginning

  var traits = {
    last_login: formatTimestamp(new Date())
  }
  traits['version-' + VERSION] = true

  if (context.enterprise) {
    const enterpriseId = 'enterprise-' + context.enterprise
    ids.push(enterpriseId)
    // traits[enterpriseId] = true
  }

  if (context.organization) {
    const organizationId = 'organization-' + context.organization
    ids.push(organizationId)
    // traits[organizationId] = true
  }

  if (context.board) {
    const boardId = 'board-' + context.board
    ids.push(boardId)
    // traits[boardId] = true
  }

  const memberId = 'member-' + context.member
  ids.push(memberId)

  return (flagsmithInitialized ? Promise.resolve() : flagsmith.init({
    api: FLAGSMITH_API,
    environmentID: FLAGSMITH_ENV,
    cacheFlags: false,
    defaultFlags: DEFAULT_FLAGS
  }).then(() => { flagsmithInitialized = true })
    // .then(() => setTraits(memberId, traits))
    // .then(() => incrementTrait(memberId, 'logins', 1)))
    // .finally(() => updateFlags(ids, ++currentCallbackHandle))
  )
}

export function setTraits (id, traits) {
  flagsmith.identity = id
  return flagsmith.setTraits(traits)
}

export function incrementTrait (id, trait, increment) {
  flagsmith.idenity = id
  return flagsmith.incrementTrait(trait, increment)
}

export function getFlags () {
  const json = sharedStorage.getItem('feature-flags') || '{}'
  return JSON.parse(json)
}

export function getValue (key, defaultValue = undefined) {
  const value = getFlags()[key]
  return value === undefined ? defaultValue : value
}

export function hasFeature (key, defaultValue = undefined) {
  const value = getFlags()[key]
  return !!(value === undefined ? defaultValue : value)
}

export function onUpdate (fn) {
  updateCallback = fn
  if (fn) {
    window.onstorage = function (event) {
      if (event.key === 'feature-flags') {
        updateCallback(event.newValue, event.oldValue)
      }
    }
  } else {
    sharedStorage.onstorage = undefined
  }
}

function updateFlags (ids, callbackHandle) {
  // Temporarily disabled
  /*
  if (currentCallbackHandle !== callbackHandle) {
    return Promise.resolve()
  } else {
    return Promise.mapSeries(ids, (id) => flagsmith.identify(id).then(() => {
      if (id !== null) {
        const idType = id.substr(0, id.indexOf('-'))
        const typeTrait = flagsmith.getTrait('user_type')
        if (idType !== typeTrait) {
          return flagsmith.setTrait('user_type', idType)
        }
      }
    }).then(() => flagsmith.getAllFlags()))
      .then((rawFlags) => {
        const defaultFlags = flattenFlags(rawFlags.shift())
        var newFlags = Object.assign({}, defaultFlags)
        // Iterate over all ids
        for (const fls of rawFlags) {
          // For each id, iterate over all flags
          for (var [key, value] of Object.entries(flattenFlags(fls))) {
            const s = '' + value
            const override = s.startsWith('!')
            if (override || s.startsWith('\\!')) {
              value = s.substr(1)
            }
            if (override || value !== defaultFlags[key]) {
              newFlags[key] = value
            }
          }
        }
        storeFlags(newFlags)
        if (updateCallback) {
          updateCallback(newFlags, oldFlags)
        }
        oldFlags = newFlags
        return newFlags
      })
      .finally(() => {
        const interval = getValue('feature_flags_update_interval')
        if (interval > 0) {
          const uh = ++currentCallbackHandle
          setTimeout(() => { updateFlags(ids, uh) }, interval)
        }
      })
  }
      */
}

function storeFlags (flags) {
  const json = JSON.stringify(flags)
  sharedStorage.setItem('feature-flags', json)
}

function flattenFlags (flags) {
  var mapped = {}
  for (const [key, value] of Object.entries(flags)) {
    if (value === Object(value)) { // Check if value is an object or of primitive type
      mapped[key] = FLAGS[key].isConfig ? value.value : value.enabled
    } else {
      return flags
    }
  }
  return mapped
}

function formatTimestamp (date) {
  const year = date.getUTCFullYear()
  const month = twoDigits(date.getUTCMonth() + 1)
  const day = twoDigits(date.getUTCDate())
  const hours = twoDigits(date.getUTCHours())
  const minutes = twoDigits(date.getUTCMinutes())
  const seconds = twoDigits(date.getUTCSeconds())
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

function twoDigits (n) {
  if (n < 10) {
    n = '0' + n
  }
  return n
}
